import { render, staticRenderFns } from "./midAutumn.vue?vue&type=template&id=7830fce6&"
import script from "./midAutumn.vue?vue&type=script&lang=js&"
export * from "./midAutumn.vue?vue&type=script&lang=js&"
import style0 from "./midAutumn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports